import config from '../config';
import { customFetch, authHeader, jsonHeader, handleResponse, commonRequestOptions } from '../helpers';

const endpointPath = 'network/person'

export const personService = {
    getAll,
    search,
    getRelationTypes,
    getUsers,
    getByUuid,
    create,
    bulkCreate,
    update,
    destroy,
    addRelation,
    removeRelation,
    addKayentaContact,
    removeKayentaContact,
    addLink,
    updateLink,
    removeLink,
};

function getAll(signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

function search(q, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/search?q=${encodeURIComponent(q || '')}`, requestOptions, signal).then(handleResponse);
}

function getRelationTypes(signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/relation-types`, requestOptions, signal).then(handleResponse);
}

// Scoped-down Kayenta-person list for the Kayenta-kontakt picker (not the admin-only
// /user/all — see the API controller's comment).
function getUsers(signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/users`, requestOptions, signal).then(handleResponse);
}

function getByUuid(uuid, signal) {
    const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}`, requestOptions, signal).then(handleResponse);
}

function create(item, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(item) };
    return customFetch(`${config.api.url}/${endpointPath}`, requestOptions, signal).then(handleResponse);
}

// `kayentaContactUserIds` is the batch-level "gäller alla rader" default; a row may still
// carry its own kayenta_contact_user_ids to override it.
function bulkCreate(persons, kayentaContactUserIds, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify({ persons, kayenta_contact_user_ids: kayentaContactUserIds || [] }) };
    return customFetch(`${config.api.url}/${endpointPath}/bulk`, requestOptions, signal).then(handleResponse);
}

function update(uuid, item, signal) {
    const requestOptions = { method: 'PUT', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(item) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}`, requestOptions, signal).then(handleResponse);
}

function destroy(uuid, signal) {
    const requestOptions = { method: 'DELETE', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}`, requestOptions, signal).then(handleResponse);
}

function addRelation(uuid, relationTypeId, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify({ relation_type_id: relationTypeId }) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/relations`, requestOptions, signal).then(handleResponse);
}

function removeRelation(uuid, relationTypeId, signal) {
    const requestOptions = { method: 'DELETE', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/relations/${relationTypeId}`, requestOptions, signal).then(handleResponse);
}

function addKayentaContact(uuid, userId, note, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify({ user_id: userId, note: note || null }) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/kayenta-contacts`, requestOptions, signal).then(handleResponse);
}

function removeKayentaContact(uuid, userId, signal) {
    const requestOptions = { method: 'DELETE', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/kayenta-contacts/${userId}`, requestOptions, signal).then(handleResponse);
}

function addLink(uuid, link, signal) {
    const requestOptions = { method: 'POST', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(link) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/links`, requestOptions, signal).then(handleResponse);
}

function updateLink(uuid, linkId, link, signal) {
    const requestOptions = { method: 'PUT', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions(), body: JSON.stringify(link) };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/links/${linkId}`, requestOptions, signal).then(handleResponse);
}

function removeLink(uuid, linkId, signal) {
    const requestOptions = { method: 'DELETE', headers: { ...authHeader(), ...jsonHeader() }, ...commonRequestOptions() };
    return customFetch(`${config.api.url}/${endpointPath}/${uuid}/links/${linkId}`, requestOptions, signal).then(handleResponse);
}
